import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { type ActionButton } from '@bizzdesign/shared/models';
import { baseRoutes } from '@bizzdesign/shared/utils';
import { CallToActionComponent } from '@bizzdesign/ui-call-to-action';

@Component({
  selector: 'bd-internal-server-error',
  imports: [CallToActionComponent, SharedI18nModule],
  standalone: true,
  templateUrl: './internal-server-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalServerErrorComponent {
  public reloadApplication(): void {
    window.location.assign(`/${baseRoutes.home}`);
  }

  readonly actionButton: ActionButton = {
    labelKey: 'errorPage.reload',
    tScope: 'uiComponents',
    onClick: () => this.reloadApplication(),
  };
}
